import axios from 'axios'
export default {
  selectOrder ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/Detail?id=' + id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('toggleOrderDetailsModal', true)
        commit('loadOrderDetails', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  cancelOrder ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      commit('toggleLoadingOrderActions', true)
      axios({
        method: 'post',
        url: process.url + 'Pedido/Cancel?provider=' + state.selectedOrder.id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('toggleLoadingOrderActions', false)
        commit('updateRegisteredOrders', response.data.resultado)
        commit('toggleOrderDetailsModal', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toggleLoadingOrderActions', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  acceptOrder ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      commit('toggleLoadingOrderActions', true)
      axios({
        method: 'post',
        url: process.url + 'Pedido/Accept?provider=' + state.selectedOrder.id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('toggleLoadingOrderActions', false)
        commit('updateRegisteredOrders', response.data.resultado)
        commit('toggleOrderDetailsModal', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toggleLoadingOrderActions', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getAllOrders ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/All?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadOrders', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getFeaturedNewOrders ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingFeatured', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/New?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingFeatured', false)
        commit('loadOrders', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingFeatured', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getNewOrders ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/New?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadOrders', response.data.resultado)
      })
      .catch((error) => {
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getInProgressOrders ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/InProgress?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadOrders', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getFinishedOrders ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/Finished?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadOrders', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getCanceledOrders ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/Canceled?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadOrders', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  printOrder ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/Print?id=' + id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('toggleOrderDetailsModal', true)
        commit('loadOrderPrint', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/pedido/actions.js